import React from 'react';
import ClassManagement from '../business/LessonManagement';
import { useAuth } from '../contexts/AuthContext';

const StaffClasses: React.FC = () => {
  const { user } = useAuth();

  if (!user?.facilityId || !user?.businessId) {
    return <div>No facility assigned. Please contact your administrator.</div>;
  }

  return (
    <div className="staff-court-reservations">
      <ClassManagement facilityId={user.facilityId} businessId={user.businessId} />
    </div>
  );
};

export default StaffClasses; 